import { Book } from '@apis/index'
import { Config } from '@apis/types'
import Button from '@components/button'
import Column from '@components/column'
import { StyleFlexColumnCenter } from '@components/styles'
import SvgImage from '@components/svg'
import { Constant } from '@utils/index'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import BookLoader from './loader/bookLoading'
import {
  AuthorName,
  BookCategory,
  BookDetails,
  BookImage,
  BookName,
  CoverImage,
  IndividualBook,
  NoBooks,
  StyleAllBooks,
  Title,
} from './style'

const Books = ({ params, setParams }: any) => {
  const navigate = useNavigate()

  const [isLoadMore, setIsLoadMore] = useState<boolean>(false)
  const selectedGenre = useSelector((state: any) => state.selectedGenre)
  const {
    items: books,
    loading,
    totalPages,
    page,
  } = useSelector((state: any) => state.books)
  const { data: user } = useSelector((state: any) => state.user)

  const fetchBooks = async (action: Config['store']['action'], params: any) => {
    await Book.getBooks(action, params).catch((error) => {
      console.error('Error fetching books:', error)
    })
  }

  const ScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    if (!books?.length) {
      fetchBooks('set', params)
    }
  }, [])
  return (
    <>
      <Column rowGap={24}>
        <Column>
          <Title>{'All Books'} </Title>
          <span>{books?.categoryData?.name}</span>
          <span style={{ color: 'grey', fontSize: '14px' }}>
            Browse Our Extensive Collection of Books Across Different Genres
          </span>
        </Column>
        <StyleAllBooks>
          {!!loading && !isLoadMore ? (
            <>
              {Array(10)
                .fill(0)
                .map((_, index) => (
                  <BookLoader key={index.toString()} />
                ))}
            </>
          ) : !!books.length ? (
            <>
              {books.map((book: any) => (
                <IndividualBook
                  key={book.id}
                  onClick={() => {
                    if (!!user?.id) {
                      navigate(`/books/${book.name}/${book.id}`)
                      ScrollToTop()
                    } else {
                      navigate(`/${book.name}/${book.id}`)
                      ScrollToTop()
                    }
                  }}
                >
                  <CoverImage>
                    <BookImage
                      src={
                        book?.coverImage
                          ? `${process.env.BUCKET_URL}/${book.coverImage}`
                          : Constant.defaultNoImage
                      }
                      alt={book.name}
                    />
                  </CoverImage>
                  <BookDetails>
                    <BookName>{book.name}</BookName>
                    <AuthorName>{book.author}</AuthorName>
                    <BookCategory>
                      {book?.categoryData?.name || 'Unknown Category'}
                    </BookCategory>
                  </BookDetails>
                </IndividualBook>
              ))}
              {!!isLoadMore && (
                <>
                  {Array(2)
                    .fill(0)
                    .map((_, index) => (
                      <BookLoader key={index.toString()} />
                    ))}
                </>
              )}
            </>
          ) : (
            <NoBooks>
              <StyleFlexColumnCenter>
                <SvgImage src="noBooksIcon" />
                <span>No Books Available</span>
              </StyleFlexColumnCenter>
            </NoBooks>
          )}
        </StyleAllBooks>
        {page < totalPages && (
          <Button
            title="Load More..."
            type="button"
            styleButton="width: fit-content; margin: 16px auto;"
            onClick={async () => {
              const updateParams = {
                ...params,
                page: params?.page + 1,
                category: selectedGenre || null,
              }

              if (updateParams?.page <= totalPages) {
                setIsLoadMore(true)
                await fetchBooks('append', updateParams)
                  .then(() => {
                    setParams(updateParams)
                  })
                  .catch(() => {})
                  .finally(() => {
                    setIsLoadMore(false)
                  })
              }
            }}
          />
        )}
        {/* <Row justifyContent="space-between" alignItems="center">
          <Column>
            <Title>{showAll ? 'All Books' : 'Latest Books'} </Title>
            <span>{books?.categoryData?.name}</span>
            <span style={{ color: 'grey', fontSize: '14px' }}>
              Browse Our Extensive Collection of Books Across Different Genres
            </span>
          </Column>

          <ShowAllButton
            style={{ marginTop: '8px' }}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'View Less' : 'Show All'}
          </ShowAllButton>
        </Row>

        {!showAll ? (
          <BookListing>
            {loading ? (
              <>
                {Array(10)
                  .fill(0)
                  .map((_, index) => (
                    <BookLoader key={index.toString()} />
                  ))}
              </>
            ) : !!books.length ? (
              books.map((book: any) => (
                <IndividualBook
                  key={book.id}
                  onClick={() => {
                    if (!!user?.id) {
                      navigate(`/books/${book.name}/${book.id}`)
                      ScrollToTop()
                    } else {
                      navigate(`/${book.name}/${book.id}`)
                      ScrollToTop()
                    }
                  }}
                >
                  <CoverImage>
                    <BookImage
                      src={
                        book?.coverImage
                          ? `${process.env.BUCKET_URL}/${book.coverImage}`
                          : Constant.defaultNoImage
                      }
                      alt={book.name}
                    />
                  </CoverImage>
                  <BookDetails>
                    <BookName>{book.name}</BookName>
                    <AuthorName>{book.author}</AuthorName>
                    <BookCategory>
                      {book?.categoryData?.name || 'Unknown Category'}
                    </BookCategory>
                  </BookDetails>
                </IndividualBook>
              ))
            ) : (
              <NoBooks>
                <StyleFlexColumnCenter>
                  <SvgImage src="noBooksIcon" />
                  <span>No Books Available</span>
                </StyleFlexColumnCenter>
              </NoBooks>
            )}
          </BookListing>
        ) : (
          <>
            <StyleAllBooks>
              {!!loading && !isLoadMore ? (
                <>
                  {Array(10)
                    .fill(0)
                    .map((_, index) => (
                      <BookLoader key={index.toString()} />
                    ))}
                </>
              ) : !!books.length ? (
                <>
                  {books.map((book: any) => (
                    <IndividualBook
                      key={book.id}
                      onClick={() => {
                        if (!!user?.id) {
                          navigate(`/books/${book.name}/${book.id}`)
                          ScrollToTop()
                        } else {
                          navigate(`/${book.name}/${book.id}`)
                          ScrollToTop()
                        }
                      }}
                    >
                      <CoverImage>
                        <BookImage
                          src={
                            book?.coverImage
                              ? `${process.env.BUCKET_URL}/${book.coverImage}`
                              : Constant.defaultNoImage
                          }
                          alt={book.name}
                        />
                      </CoverImage>
                      <BookDetails>
                        <BookName>{book.name}</BookName>
                        <AuthorName>{book.author}</AuthorName>
                        <BookCategory>
                          {book?.categoryData?.name || 'Unknown Category'}
                        </BookCategory>
                      </BookDetails>
                    </IndividualBook>
                  ))}
                  {!!isLoadMore && (
                    <>
                      {Array(2)
                        .fill(0)
                        .map((_, index) => (
                          <BookLoader key={index.toString()} />
                        ))}
                    </>
                  )}
                </>
              ) : (
                <NoBooks>
                  <StyleFlexColumnCenter>
                    <SvgImage src="noBooksIcon" />
                    <span>No Books Available</span>
                  </StyleFlexColumnCenter>
                </NoBooks>
              )}
            </StyleAllBooks>
            {page < totalPages && (
              <Button
                title="Load More..."
                type="button"
                styleButton="width: fit-content; margin: 16px auto;"
                onClick={async () => {
                  const updateParams = {
                    ...params,
                    page: params?.page + 1,
                    category: selectedGenre || null,
                  }

                  if (updateParams?.page <= totalPages) {
                    setIsLoadMore(true)
                    await fetchBooks('append', updateParams)
                      .then(() => {
                        setParams(updateParams)
                      })
                      .catch(() => {})
                      .finally(() => {
                        setIsLoadMore(false)
                      })
                  }
                }}
              />
            )}
          </>
        )} */}
      </Column>
    </>
  )
}

export default Books
